import React, { useState, useEffect } from "react";
import { contentClient } from "../../AxiosClient";
import DisplayTemplate from "./DisplayTemplate";

function DiffRevisions(props) {
  const [diff, setDiff] = useState("");
  const [diffRevision, setDiffRevision] = useState({});
  useEffect(
    () => {
      if (props.diffRevisionNumber === null) {
        return;
      }
      contentClient
        .get(
          `/knowledgeitem/${
            props.currentRevision.contentRVO.itemId
          }/revision/number/${props.diffRevisionNumber}`
        )
        .then((res) => {
          if (res.data) {
            setDiffRevision(res.data);
          } else {
            setDiffRevision(res);
          }
        });
    },
    [props.diffRevisionNumber]
  );

  return (
    <>
      {props.diffRevisionNumber !== null ? (
        <DisplayTemplate
          {...props}
          isNotTemplate
          isDiff
          diffRevision={diffRevision}
        />
      ) : (
        <DisplayTemplate {...props} isNotTemplate />
      )}
    </>
  );
}

export default DiffRevisions;
